module.exports = __webpack_public_path__ + "img/note.48169faf.svg";